import { render, staticRenderFns } from "./change_order.vue?vue&type=template&id=4bd84cdb&scoped=true&"
import script from "./change_order.vue?vue&type=script&lang=js&"
export * from "./change_order.vue?vue&type=script&lang=js&"
import style0 from "./change_order.vue?vue&type=style&index=0&id=4bd84cdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd84cdb",
  null
  
)

export default component.exports